import lodash from "lodash";
import { TYPES } from "./bailiff_dialog.type";
import {
  onSnapshot,
  query,
  where,
  doc,
  updateDoc,
  orderBy,
  getDocs,
  limit,
  getCountFromServer,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const storage = getStorage(app, "gs://vi-viet-nam-bailiff.firebasestorage.app");
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
const allBailiffDialogSub = [];
export const snapBailiffDialog =
  ({ id }, callback) =>
  (dispatch) => {
    setBailiffDialogAllSuccess(dispatch, null);
    setBailiffDialogMergedRawSuccess(dispatch, []);
    const cRef = getRefs().dialog;
    const uid = auth?.currentUser?.uid;
    const c0 = where("bailiff", "==", id);
    const c1 = where("client", "==", uid);
    const c2 = orderBy("slot", "asc");
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        const mergered = renderMerged({ data });
        setBailiffDialogAllSuccess(dispatch, data);
        setBailiffDialogMergedRawSuccess(dispatch, mergered);
        if (callback) {
          callback();
        }
      }
    });
    allBailiffDialogSub.push(unsub);
  };

export const unSnapBailiffDialog = () => (dispatch) => {
  allBailiffDialogSub.forEach((subscriber) => {
    subscriber();
  });
  allBailiffDialogSub.length = 0;
};

const renderMerged = ({ data }) => {
  let result = [];
  const datas = lodash.cloneDeep(data) || [];
  datas?.forEach((item, dIndex) => {
    const bailiff = item?.bailiff;
    const id = item?.id;
    const combine = item?.sentences || [];
    const remapCombine = combine?.map((c, index) => ({
      ...c,
      bailiff,
      segId: id + "." + dIndex + "." + index,
      id,
    }));
    result.push(...remapCombine);
  });

  return result;
};

// update dialog bailiff sentences.
export const updateDialogBailiff =
  ({ id, slot, text, selected }, callback) =>
  (dispatch) => {
    const cRef = getRefs().dialog;
    const dRef = doc(cRef, id);
    const sentences = selected?.sentences || [];
    const exist =
      sentences?.map((s) => {
        const isSlot = s?.slot === slot;
        if (!isSlot) return s;
        const fixCount = s?.fixCount || 0;
        return { ...s, fix: text, fixed: true, fixCount: fixCount + 1 };
      }) || [];

    const updated = {
      sentences: exist,
    };

    updateDoc(dRef, updated)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        callback &&
          callback({ status: 500, err: err?.message || "Please try again!" });
      });
  };

// add more sentences bailiff
export const addModeDialogBailiff =
  ({ id, slot, arrays, selected }, callback) =>
  (dispatch) => {
    const cRef = getRefs().dialog;
    const dRef = doc(cRef, id);
    const sentences = selected?.sentences || [];
    const exist = renderExtraResult(sentences, arrays, slot);
    const updated = {
      sentences: exist,
    };

    updateDoc(dRef, updated)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        callback &&
          callback({ status: 500, err: err?.message || "Please try again!" });
      });
  };

const renderExtraResult = (sentences, array, slot) => {
  const result = [];
  sentences?.forEach((s) => {
    if (s?.slot === slot) {
      array.forEach((a) => {
        const object = { ...s, ...a };
        result.push(object);
      });
    } else {
      result.push(s);
    }
  });

  const final = result?.map((r, index) => ({ ...r, slot: index + 1 }));

  return final;
};

// snap the dialog preview by bailiff.
export const getBailiffDialogPreview =
  ({ id }, callback) =>
  async (dispatch) => {
    // tính toán số lượng dialog.
    const cRef = getRefs().dialog;
    const client = auth?.currentUser?.uid;
    const count = await caculateTotalDialog({ cRef, id, client });

    let limitNumber = 3;
    if (count <= 3) {
      limitNumber = 1;
    }
    setBailiffDialogPreviewSuccess(dispatch, null);
    const c0 = where("bailiff", "==", id);
    const c1 = where("client", "==", client);
    const c2 = orderBy("slot", "asc");
    const c3 = limit(limitNumber);
    const qRef = query(cRef, c0, c1, c2, c3);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        console.log({ data });
        setBailiffDialogPreviewSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

const caculateTotalDialog = async ({ cRef, id, client }) => {
  const c0 = where("bailiff", "==", id);
  const c1 = where("client", "==", client);
  const qRef = query(cRef, c0, c1);
  const snapshot = await getCountFromServer(qRef);
  return snapshot.data().count || 0;
};

// ========= cloud function =========//
export const getAudioUrlFromBailiff =
  ({ id }, callback) =>
  (dispatch) => {
    setBailiffDialogUrlAudioSuccess(dispatch, null);
    const uid = auth?.currentUser?.uid;
    console.log({ uid });
    const path = `client/${uid}/bailiff/${id}/raw.mp3`;
    const refstorage = ref(storage, path);
    getDownloadURL(refstorage)
      .then((url) => {
        console.log({ url });
        setBailiffDialogUrlAudioSuccess(dispatch, url);
      })
      .catch((err) => {
        console.log({ err });
      });
  };
// ========= cloud function =========//
// ========= local function =========//
export const setBailiffDialogAll = (data, callback) => (dispatch) => {
  setBailiffDialogAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogOpenAdd = (data, callback) => (dispatch) => {
  setBailiffDialogOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogOpenEdit = (data, callback) => (dispatch) => {
  setBailiffDialogOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogSelected = (data, callback) => (dispatch) => {
  setBailiffDialogSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogOpenSplit = (data, callback) => (dispatch) => {
  setBailiffDialogOpenSplitSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogSearch = (data, callback) => (dispatch) => {
  setBailiffDialogSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogSecond = (data, callback) => (dispatch) => {
  setBailiffDialogSecondSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogPlay = (data, callback) => (dispatch) => {
  setBailiffDialogPlaySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogSlot = (data, callback) => (dispatch) => {
  setBailiffDialogSlotSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogGap = (data, callback) => (dispatch) => {
  setBailiffDialogGapSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogOptionSpeaker = (data, callback) => (dispatch) => {
  setBailiffDialogOptionSpeakerSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setBailiffDialogKick = (data, callback) => (dispatch) => {
  setBailiffDialogKickSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const resetAll = (callback) => (dispatch) => {
  setBailiffDialogPlaySuccess(dispatch, false);
  setBailiffDialogSlotSuccess(dispatch, 0);
  setBailiffDialogSecondSuccess(dispatch, 0);
  setBailiffDialogKickSuccess(dispatch, null);
};

// refine data for visualize.
export const refineDataForVisualize = (data) => {
  let result = lodash.cloneDeep(data) || [];
  const sentences = result?.sentences || [];
  const inserts = result?.inserts || [];
  const deletes = result?.deletes || [];

  const filterSens =
    sentences?.filter((s) => !deletes?.includes(s?.slot)) || [];
  const sums = [...filterSens, ...inserts];
  const sortSum = lodash.orderBy(sums, ["start"], ["asc"]);
  return sortSum;
};

// ========= dispatch =========//

const setBailiffDialogAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_ALL,
    payload: data,
  });
};

const setBailiffDialogOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_OPEN_ADD,
    payload: data,
  });
};

const setBailiffDialogOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_OPEN_EDIT,
    payload: data,
  });
};

const setBailiffDialogSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SELECTED,
    payload: data,
  });
};

const setBailiffDialogSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SEARCH,
    payload: data,
  });
};

const setBailiffDialogUrlAudioSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_URL_AUDIO,
    payload: data,
  });
};

const setBailiffDialogSecondSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SECOND,
    payload: data,
  });
};

const setBailiffDialogPlaySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_PLAY,
    payload: data,
  });
};

const setBailiffDialogSlotSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_SLOT,
    payload: data,
  });
};

const setBailiffDialogGapSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_GAP,
    payload: data,
  });
};

const setBailiffDialogOpenSplitSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_OPEN_SPLIT,
    payload: data,
  });
};

const setBailiffDialogOptionSpeakerSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_OPTION_SPEAKER,
    payload: data,
  });
};

const setBailiffDialogPreviewSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_PREVIEW,
    payload: data,
  });
};

const setBailiffDialogKickSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_KICK,
    payload: data,
  });
};

const setBailiffDialogMergedRawSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_BAILIFF_DIALOG_MERGED_RAW,
    payload: data,
  });
};
